import axios from 'axios';

export default class BillingMetric {
  constructor({ baseURL }) {
    this.baseURL = baseURL;
  }

  async callPolicyMetric(brandId, policy) {
    const result = await axios.post(`${this.baseURL}/${brandId}/billing-metric`, policy);
    return result.data;
  }
}
